<template>
    <RowColumn :sm-size="smSize" :md-size="mdSize" type="form-row">
        <SubmitButton
            :btn-variant="btnVariant"
            :is-disabled="isDisabled"
            :is-loading="isLoading"
            :do-action="doAction"
            :text="text"
        />
    </RowColumn>
</template>

<script>
    import SubmitButton from "./html/SubmitButton";
    import RowColumn from "./RowColumn";

    export default {
        name: "SubmitRow",
        components: {RowColumn, SubmitButton},
        props: {
            isLoading: {
                type: Boolean,
                required: true,
            },
            doAction: {
                type: Function,
                default: function () {
                }
            },
            isDisabled: {
                type: Boolean,
                default: false,
            },
            text: {
                type: String,
                default: "add",
            },
            mdSize: {
                type: String,
                default: "3"
            },
            smSize: {
                type: String,
                default: "4"
            },
            btnVariant: {
                type: String,
                default: "btn bg-main border-0 hover:bg-hoverMain rounded h-11 focus:ring-0 font-bold w-full",
            }
        },

    }
</script>

<style scoped>

</style>